import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Flex } from '@chakra-ui/react';

import RequirementTemplateBlueprintType from '../../types/RequirementTemplateBlueprintType';

import RequirementTemplateLeftBox from './components/RequirementTemplateLeftBox';
import RequirementTemplateRightBox from './components/RequirementTemplateRightBox';
import TemplateBuilderListRequirementsBox from './components/TemplateBuilderListRequirementsBox';

function RequirementTemplateBuilder({ blueprint }) {
  const dispatch = useDispatch();
  const contentHeight = useSelector(blueprint.selectBuilderHeight);

  useEffect(() => () => dispatch(blueprint.resetRequirementTemplateState()), [dispatch]);

  return (
    <Flex
      h={contentHeight}
      justifyContent="space-between"
    >
      <RequirementTemplateLeftBox blueprint={blueprint} />
      <TemplateBuilderListRequirementsBox blueprint={blueprint} />
      <RequirementTemplateRightBox blueprint={blueprint} />
    </Flex>
  );
}

RequirementTemplateBuilder.propTypes = { blueprint: RequirementTemplateBlueprintType };

export default RequirementTemplateBuilder;
